module.exports = __webpack_public_path__ + "img/vacunas.84d77033.jpg";